import { NavLink } from 'react-router-dom'
import { UserButton } from '@clerk/react'
import { LayoutDashboard, Mail, Send } from 'lucide-react'

const navItems = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/newsletters', label: 'Newsletters', icon: Mail, end: false },
  { to: '/push', label: 'Push', icon: Send, end: false },
]

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-bone-50 dark:bg-marrow-900">
      <aside className="flex w-60 flex-col border-r border-bone-200 bg-bone-100 dark:border-marrow-700 dark:bg-marrow-800">
        <div className="flex h-16 items-center border-b border-bone-200 px-6 dark:border-marrow-700">
          <span className="font-serif text-xl font-semibold tracking-tight text-marrow-900 dark:text-bone-50">
            Marrow
          </span>
          <span className="ml-2 rounded bg-rust-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-rust-600">
            Admin
          </span>
        </div>
        <nav className="flex-1 space-y-1 px-3 py-4">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                [
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition',
                  isActive
                    ? 'bg-rust-500/10 text-rust-700 dark:text-rust-500'
                    : 'text-marrow-800/80 hover:bg-bone-200/60 dark:text-bone-200/80 dark:hover:bg-marrow-700/60',
                ].join(' ')
              }
            >
              <Icon size={16} aria-hidden />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-bone-200 p-4 dark:border-marrow-700">
          <div className="flex items-center justify-between gap-3">
            <UserButton />
            <span className="truncate text-xs text-marrow-800/60 dark:text-bone-200/60">
              Round 8
            </span>
          </div>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-5xl px-8 py-10">{children}</div>
      </main>
    </div>
  )
}
